<template>
  <el-form
    ref="levelRightsFilterRef"
    class="search-form"
    :inline="true"
    :model="form"
    label-width="128px"
    @keyup.native.enter="handleSearch"
  >
    <el-row :class="openMore ? 'search-bar-content-show' : 'search-bar-content-close'">
      <el-col :span="8">
        <el-form-item label="起止日期">
          <el-date-picker
            v-model="form.dateRange"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
          />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="姓名">
          <el-input
            v-model="form.unifyNameLike"
            placeholder="请输入姓名"
            clearable
            @clear="handleSearch"
          />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="手机">
          <el-input
            v-model="form.mobile"
            placeholder="请输入手机"
            clearable
            @clear="handleSearch"
          />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="分子公司">
          <el-select
            v-model="form.companyIds"
            filterable
            remote
            collapse-tags
            clearable
            :loading="loading"
            reserve-keyword
            multiple
            placeholder="请输入"
            :remote-method="remoteMethod"
            @clear="handleSearch"
          >
            <el-option
              v-for="item in options"
              :key="item.companyId"
              :label="item.companyName"
              :value="item.companyId"
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="鉴别结果">
          <el-select
            v-model="form.status"
            clearable
            placeholder="请选择"
            @clear="handleSearch"
          >
            <el-option
              v-for="item in RESULT_TYPE_LIST"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <div class="search-btns">
          <div class="moreData" @click="openMore = !openMore">
            {{ !openMore ? "展开筛选" : "收起筛选" }}
            <el-icon :class="openMore ? 'el-icon-caret-top' : 'el-icon-caret-bottom'" />
          </div>
          <div class="form-btns">
            <el-button class="form-btn" @click.native.prevent="handleBack">
              返 回
            </el-button>
            <el-button
              class="form-btn"
              type="primary"
              @click.native.prevent="handleSearch"
            >
              查 询
            </el-button>
            <el-button
              class="form-btn"
              @click.native.prevent="handleExport"
            >
              导 出
            </el-button>
          </div>
        </div>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import { getOdooCompany } from '@/api/systemNotice';
import { TASK_LIST, RESULT_TYPE_LIST } from '../constant';

export default {
  name: 'ListFilter',
  props: {
    form: {
      type: Object,
      default: () => ({}),
    },
    active: {
      type: String,
      default: 'first',
    },
  },
  data() {
    const millisecondOfDay = 1 * 24 * 60 * 60 * 1000;
    return {
      labelWidth: '128px',
      openMore: true,
      loading: false,
      options: [],
      TASK_LIST,
      RESULT_TYPE_LIST,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() || time.getTime() < Date.now() - 60 * millisecondOfDay;
        },
      },
    };
  },
  methods: {
    handleSearch() {
      this.$emit('search');
    },
    handleReset() {
      this.$emit('reset');
    },
    handleExport() {
      this.$emit('export');
    },
    handleBack() {
      this.$emit('back');
    },
    async remoteMethod(query) {
      if (query !== '') {
        this.loading = true;
        const result = await getOdooCompany({ name: query });
        this.loading = false;
        this.options = result.map((v) => ({ companyId: v.id, companyName: v.name }));
      } else {
        this.options = [];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.search-btns {
  float:right;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  .moreData {
    font-size: 12px;
    color: #606266;
    margin-right: 28px;
    &:hover {
      cursor: pointer;
    }
    [class*=" el-icon-"],
    [class^="el-icon-"] {
      color: #06b880 !important;
      font-family: "element-icons" !important;
    }
  }
}
.search-form ::v-deep {
  .el-col {
    margin: 5px 0;
    .el-form-item {
      width: 100%;
      margin: 0;
      .el-form-item__label {
        white-space: nowrap;
        overflow: hidden;
      }
      .el-form-item__content {
        width: calc(100% - 128px);
        .el-select {
          width: 100%;
        }
      }
    }
  }
  .el-date-editor {
    width: 100%;
  }
}
.search-bar-content-close::v-deep {
  .el-col {
    display: none !important;
  }
  .el-col:nth-child(1) {
    display: block !important;
  }
  .el-col:nth-child(2) {
    display: block !important;
  }
  .el-col:nth-child(3) {
    display: block !important;
  }
  .el-col:nth-last-child(1) {
    float: right !important;
    display: block !important;
  }
}
.search-bar-content-show::v-deep {
  .el-col:nth-last-child(1) {
    float: right !important;
  }
}
</style>
